// extracted by mini-css-extract-plugin
export default {"pillsContainer":"PillsToolbar_pillsContainer__itd-P","pill":"PillsToolbar_pill__VI3ok","pillBorder":"PillsToolbar_pillBorder__yJzYQ"};